import styled from "styled-components";

interface IPCompensationDetail {
  paddingRight?: string;
}
export const PCompensationDetail = styled.p<IPCompensationDetail>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    padding-right: ${props.paddingRight ? props.paddingRight : "0rem"};
  `}
  color: #2E353D;
  font-size: 1.4rem;
  height: auto;
  line-height: 2rem;
  overflow-wrap: break-word;
  width: 32rem;
`;

export const H2CompensationTitle = styled.h2`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: rgba(46, 53, 61, 0.3);
  font-size: 1.4rem;
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 3rem 1rem 3rem 3rem;
  width: 100%;

  h1 {
    color: #2e353d;
    font-family: "Montserrat";
    font-size: 2rem;
    font-style: normal;
    font-weight: 800;
    line-height: 2.4rem;
  }

  .container-labels {
    align-items: center;
    display: flex;
    justify-content: center;
    div {
      margin-bottom: 2rem;
      width: 50%;
      h2 {
        color: rgba(46, 53, 61, 0.3);
        font-family: "Montserrat";
        font-size: 1.4rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.7rem;
        margin-bottom: 0.8rem;
      }
      p {
        color: #2e353d;
        font-family: "Montserrat";
        font-size: 1.6rem;
        font-style: normal;
        font-weight: 500;
        height: 6rem;
        line-height: 2rem;
        margin-right: 1rem;
        overflow-wrap: break-word;
      }
      label {
        color: #2e353d;
        font-family: "Montserrat";
        font-size: 1.6rem;
        font-style: normal;
        font-weight: 500;
        line-height: 2rem;
      }
    }
  }
`;
